module.exports = __webpack_public_path__ + "static/logo_ogw2-f6c8313474d995e56fa8eb05de969e85.png";